const { useEffect } = require("react")

const usePagesSEO = ({
    pageTitle,
    pageDescription,
    pageKeywords=[],
    ogTitle,
    ogDescription,
    ogImage,
    ogUrl,
}) => {
 useEffect(()=>{
    document.title = pageTitle || "Default Title";
    setMetgaTag('name', 'description', pageDescription || "Default Description");
    setMetgaTag('name', 'keywords', pageKeywords.join(', ') || "Default Keywords");
    setMetgaTag('property', 'og:title', ogTitle || pageTitle || "Default OG Title");
    setMetgaTag('property', 'og:description', ogDescription || pageDescription || "Default OG Description");
    setMetgaTag('property', 'og:image', ogImage );
    setMetgaTag('property', 'og:url', ogUrl || window.location.href);

    return () => {
     // Cleanup meta tags on unmount
    }
    
 },[
    pageTitle,
    pageDescription,
    pageKeywords,
    ogTitle,
    ogDescription,
    ogImage,
    ogUrl
 ])

 const setMetgaTag = (attr, key, content) => {
    let metaTag = document.querySelector(`meta[${attr}="${key}"]`);
    if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute(attr, key);
        document.head.appendChild(metaTag);
    }
    metaTag.setAttribute('content', content);

 }
}

export default usePagesSEO;